import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.XeroAmaxPayBatchPaymentRequestCard.BankAccountInfo', {
    accountNumber: 'Account number: {value}',
    sortCode: 'Sort code: {value}',
    iban: 'IBAN: {value}',
    changeBankAccount: 'Change bank account',
    disconnected: 'Disconnected',
});
